import { alpha, Box, Skeleton, Typography } from '@mui/material';
import { PastVisitStatFilter } from 'v2/pages/Visits/utils/pastVisitStats';
import { VisitStatFilter } from 'v2/pages/Visits/utils/visitStats';

type StatFilter = VisitStatFilter | PastVisitStatFilter;

interface Props<T extends StatFilter> {
  value: number;
  label: string;
  isLoading: boolean;
  stat: T;
  selectedStat: T;
  onStatClick: (stat: T) => void;
}

const StatTile = <T extends StatFilter>({ value, label, isLoading, stat, selectedStat, onStatClick }: Props<T>) => {
  const isSelected = selectedStat === stat;

  return (
    <Box
      p={2}
      role="button"
      tabIndex={0}
      aria-pressed={isSelected}
      onClick={() => onStatClick(stat)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onStatClick(stat);
        }
      }}
      sx={(theme) => ({
        height: '100%',
        cursor: 'pointer',
        backgroundColor: isSelected
          ? alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)
          : theme.custom.background.level3,
        border: 1,
        borderColor: isSelected ? 'primary.main' : 'transparent',
        borderRadius: 1,
        transition: theme.transitions.create(['background-color', 'border-color']),
        '&:hover': {
          backgroundColor: theme.palette.action.hover
        },
        '&:focus-visible': {
          outline: `2px solid ${theme.palette.primary.main}`,
          outlineOffset: 2
        }
      })}
    >
      {isLoading ? <Skeleton width={60} height={42} /> : <Typography variant="h4">{value}</Typography>}
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
};

export default StatTile;
